//src/App/Controllers/Sales/Invoices/index.js
import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

// const create_invoice = async (invoice) => {
//   try {
//     const data = {
//       customer: invoice?.customer,
//       project: invoice?.project,
//       number: invoice?.number,
//       date: invoice?.date,
//       due_date: invoice?.due_date,
//       lpo_number: invoice?.lpo_number,
//       lpo_date: invoice?.lpo_date,
//       reference: invoice?.reference,
//       salesman: invoice?.salesman,
//       status: invoice?.status,
//       details: invoice?.details,
//       subtotal: invoice?.subtotal,
//       taxamount: invoice?.taxamount,
//       discount_value: invoice?.discount_value,
//       discount_type: invoice?.discount_type,
//       discount: invoice?.discount,
//       delivery: invoice?.delivery,
//       delivery_status: invoice?.delivery_status,
//       delivery_date: invoice?.delivery_date,
//       payment_status: invoice?.payment_status,
//       /*  payment_types:
//          invoice?.payment_types?.length > 0
//            ? JSON?.stringify(invoice?.payment_types)
//            : "",
//        payments: JSON?.stringify(invoice?.payments), */
//       payment_types:
//         invoice?.payment_types,
//       payments: invoice?.payments,
//       total: invoice?.total,
//       status: 1,
//       source: invoice?.source || "Sales",
//     };

//     const token = localStorage.getItem("user");
//     const config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const response = await axios.post(`${APIURL}/create-invoice`, data, config);
//     return response?.data;
//   } catch (error) {
//     return error;
//   }
// };
const create_invoice = async (invoice) => {
  try {
    const data = {
      customer: invoice?.customer,
      project: invoice?.project,
      number: invoice?.number,
      date: invoice?.date,
      due_date: invoice?.due_date,
      lpo_number: invoice?.lpo_number,
      lpo_date: invoice?.lpo_date,
      reference: invoice?.reference,
      salesman: invoice?.salesman,
      status: invoice?.status,
      details: invoice?.details,
      subtotal: invoice?.subtotal,
      taxamount: invoice?.taxamount,
      discount_value: invoice?.discount_value,
      discount_type: invoice?.discount_type,
      discount: invoice?.discount,
      delivery: invoice?.delivery,
      delivery_status: invoice?.delivery_status,
      delivery_date: invoice?.delivery_date,
      payment_status: invoice?.payment_status,

      // V2 Payment Style (Not stringified)
      payment_types: invoice?.payment_types,
      payments: invoice?.payments,

      total: invoice?.total,
      status: 1,
      source: invoice?.source || "Sales",

      // ✅ Added Note & Prescription
      note: invoice?.note || "",
      prescription: invoice?.prescription 
        ? JSON.stringify(invoice?.prescription) 
        : JSON.stringify({
            R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
            L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
          }),
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-invoice`, data, config);
    return response?.data;
  } catch (error) {
    console.error("create_invoice error:", error);
    return error;
  }
};

// const update_invoice = async (invoice) => {
//   try {
//     const data = {
//       id: invoice?.id,
//       customer: invoice?.customer,
//       project: invoice?.project,
//       number: invoice?.number,
//       date: invoice?.date,
//       due_date: invoice?.due_date,
//       lpo_number: invoice?.lpo_number,
//       lpo_date: invoice?.lpo_date,
//       reference: invoice?.reference,
//       salesman: invoice?.salesman,
//       status: invoice?.status,
//       details: invoice?.details,
//       subtotal: invoice?.subtotal,
//       taxamount: invoice?.taxamount,
//       discount_value: invoice?.discount_value,
//       discount_type: invoice?.discount_type,
//       discount: invoice?.discount,
//       delivery: invoice?.delivery,
//       delivery_status: invoice?.delivery_status,
//       delivery_date: invoice?.delivery_date,
//       payment_status: invoice?.payment_status,
//       /*  payment_types:
//          invoice?.payment_types?.length > 0
//            ? JSON?.stringify(invoice?.payment_types)
//            : "",
//        payments: JSON?.stringify(invoice?.payments), */
//       payment_types: invoice?.payment_types,
//       payments: invoice?.payments,
//       total: invoice?.total,
//       status: 1,
//       source: invoice?.source || "Sales",
//     };

//     const token = localStorage.getItem("user");
//     const config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const response = await axios.post(`${APIURL}/update-invoice`, data, config);
//     return response?.data;
//   } catch (error) {
//     return error;
//   }
// };
const update_invoice = async (invoice) => {
  try {
    const data = {
      id: invoice?.id,
      customer: invoice?.customer,
      project: invoice?.project,
      number: invoice?.number,
      date: invoice?.date,
      due_date: invoice?.due_date,
      lpo_number: invoice?.lpo_number,
      lpo_date: invoice?.lpo_date,
      reference: invoice?.reference,
      salesman: invoice?.salesman,
      status: invoice?.status,
      details: invoice?.details,
      subtotal: invoice?.subtotal,
      taxamount: invoice?.taxamount,
      discount_value: invoice?.discount_value,
      discount_type: invoice?.discount_type,
      discount: invoice?.discount,
      delivery: invoice?.delivery,
      delivery_status: invoice?.delivery_status,
      delivery_date: invoice?.delivery_date,
      payment_status: invoice?.payment_status,

      // V2 Payment Style
      payment_types: invoice?.payment_types,
      payments: invoice?.payments,

      total: invoice?.total,
      status: 1,
      source: invoice?.source || "Sales",

      // ✅ Added Note & Prescription
      note: invoice?.note || "",
      prescription: invoice?.prescription 
        ? JSON.stringify(invoice?.prescription) 
        : JSON.stringify({
            R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
            L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
          }),
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-invoice`, data, config);
    return response?.data;
  } catch (error) {
    console.error("update_invoice error:", error);
    return error;
  }
};

const delete_invoice = async (invoice) => {
  try {

    const data = {
      id: invoice?.id,
      source: invoice?.source || "Sales",
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-invoice`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_invoice = async (invoice) => {
  try {
    const data = {};
    if (invoice?.id) data.id = invoice.id;
    else if (invoice?.number) data.number = invoice.number;
    else return { status: false, message: "Invoice ID or number is required" };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-invoice`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_invoices = async (invoice) => {
  try {
    const data = {
      search: invoice?.search,
      sort: invoice?.sort,
      customer: invoice?.customer,
      date: invoice?.date,
      due_date: invoice?.due_date,
      payment: invoice?.payment,
      status: invoice?.status,
      page: invoice?.page,
      source: invoice?.source,
      timezone: invoice?.timezone
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-invoices`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_invoices_details = async (invoice) => {
  try {
    const data = {
      search: invoice?.search,
      status: invoice?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-invoices-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_invoice_log = async (invoice) => {
  try {
    const data = {
      search: invoice?.search,
      sort: invoice?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-invoice-log`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_invoice_logs = async (invoice) => {
  try {
    const data = {
      search: invoice?.search,
      sort: invoice?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-invoice-logs`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_invoice,
  update_invoice,
  delete_invoice,
  get_invoice,
  get_all_invoices,
  get_all_invoices_details,
  get_invoice_log,
  get_all_invoice_logs,
};
